import { render, staticRenderFns } from "./StatsLastReviewsModal.vue?vue&type=template&id=2f6b417d&"
import script from "./StatsLastReviewsModal.vue?vue&type=script&lang=js&"
export * from "./StatsLastReviewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports